import * as React from 'react';
import { inspectionType } from '../../constants/generals';

export interface IFlaggedFormListItemProps {
    index: number;
    plantId: string;
    userId: string;
    UniqueId: string;
    onClick(UniqueId, type): void;
    formType: string;
    State: string;
    UserName: string;
    Region: string;
    Completed: boolean;
    formId: string;
}

export class FlaggedFormListItem extends React.PureComponent<IFlaggedFormListItemProps, {}> {

    static defaultProps: IFlaggedFormListItemProps;

    render() {
        const { index, plantId, userId, formType, formId , UserName, Region, State, UniqueId } = this.props;
        const type = (formType === 'Daily Form' ? 'dailyForm' : formType);
        return < div className="modal-list-item"  >
            <div className="plant-id" onClick={() => this.props.onClick(UniqueId, type)}
                style={{ width: `${20}%` }} >{plantId}</div>
            <div className="plant-id" onClick={() => this.props.onClick(UniqueId, type)}
                style={{ width: `${20}%` }} >{Region}</div>
            <div className="plant-id" onClick={() => this.props.onClick(UniqueId, type)}
                style={{ width: `${20}%` }} >{inspectionType(formId)}</div>
            <div className="plant-id" onClick={() => this.props.onClick(UniqueId, type)}
                style={{ width: `${20}%` }} >{State}</div>
            <div className="plant-id" onClick={() => this.props.onClick(UniqueId, type)}
                style={{ width: `${20}%` }} >{UserName}</div>

            <div style={{ width: `${20}%` }} onClick={() => this.props.onClick(UniqueId, type)}
                className={(!this.props.Completed ? 'pending' : 'complete') + ` clickable-list-item`} >
                {!this.props.Completed ?
                    [<i key={0} className="fa fa-clock-o"></i>, ` Pending`] :
                    [<i key={1} className="fa fa-check-circle-o"></i>, ` Complete`]
                }
            </div>
        </div >;
    }
}

const buttonStyle: React.CSSProperties = {
    width: '67.48px',
    height: '20px',
    display: 'flex',
    justifyContent: 'center'
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Dashboard/FlaggedFormListItem.tsx